import { createErrorStore } from "../../../error";
import type { FieldKey } from "../../shared/types";
import type { DirectSalesFlowSlug } from "../constants";

/**
 * Zustand store for tracking validation errors and validated fields
 * for the direct sales sign-up flow.
 */
export const useDirectSalesFlowErrorStore = createErrorStore<FieldKey, DirectSalesFlowSlug>(
  "direct-sales-suf-error-store",
);
